/**
 * @author Fernando Ruano
 * @file routes.js
 * @description App routes
 */

// Pages
import Login from '@nephro/pages/Login';
import PasswordRecovery from '@nephro/pages/PasswordRecovery';
import SetNewPassword from '@nephro/pages/SetNewPassword';
import Dashboard from '@nephro/containers/Dashboard';
import PatientRegistration from '@nephro/containers/PatientRegistration';
import LoginStaffCallbackView from '@nephro/pages/loginStaffCallback';

const pathStart = '';
const routes = [
  {
    path: `${pathStart}/`,
    component: Login,
    exact: true
  },
  {
    path: `${pathStart}/login`,
    component: Login,
    exact: true
  },
  {
    path: `${pathStart}/loginStaff`,
    component: Login,
    exact: true
  },
  {
    path: `${pathStart}/authorization-code/callback`,
    component: LoginStaffCallbackView,
    exact: true
  },
  {
    path: `${pathStart}/main`,
    isProtected: true,
    component: Dashboard
  },
  {
    path: `${pathStart}/registration`,
    isProtected: false,
    component: PatientRegistration
  },
  {
    path: `${pathStart}/passwordRecovery`,
    isProtected: false,
    component: PasswordRecovery
  },
  {
    path: `${pathStart}/setNewPassword/:token`,
    isProtected: false,
    component: SetNewPassword
  },
  { redirect: true, to: `${pathStart}/login` }
];

export default routes;
